export default __webpack_public_path__ + "static/media/h_wdt_c_0.b83b7ab9.mp3";